module.exports = __webpack_public_path__ + "img/euro.c704e2ec.svg";